var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"left-side-logo d-flex flex-column"},[_c('logo-component',{staticClass:"logo-component",attrs:{"height":"44px"}}),_c('img',{staticClass:"auth-bg",attrs:{"src":require("../../img/auth_bg.svg")}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }